<template lang="pug">
div
  h3.page-title 订单编号: {{data.order_no}}

  component(:is="formContainer.component ? formContainer.component : 'el-card'" v-loading="isLoading")
    div.card-head(slot="header")
      el-button(v-if="isEditing" type="success" @click="Submit") 保 存
      el-button(v-if="isEditing" @click="isEditing = false") 取 消
      el-button(v-if="!isEditing" type="primary" @click="isEditing = true") 编 辑
      el-button(v-if="!isEditing" @click="$router.go(-1)") 取 消
    div.card-body
      component.form(v-for="(form,index) of forms" :is="form.wrapComponent? form.wrapComponent : 'el-card'" v-bind="form.wrapAttrs" :key="index")
        template(#header v-if="form.name")
          | {{form.name}}
        common-form(
          ref="form"
          v-bind="form.attrs"
          :options="form.formInfo"
          :values="value"
          )
</template>

<script>
let paymentType = {
  // 繁体中文
  1: [
    '',
    '货到付款',
    '711',
    '全家'
  ],
  // 泰文
  2: [
    '',
    'เงินสดในการส่งมอบ',
  ],
  // 英语
  4: [
    '',
    'Cash on delivery'
  ]
}

const getLanguage = (area) => {
  // 语言的选择
  switch(area) {
    // 台湾和香港对应繁体中文
    case 1:
    case 4:
      return 1
    // 泰国对应泰语
    case 2:
      return 2
    // 马来西亚、新加坡对应英语
    case 5:
    case 6: 
      return 4
    default: 
      return 1
    
  }
}

let stateMap = [
  '',
  '待审核',
  '已通过',
  '已作废'
]
export default {
  name: 'Form',
  data() {
    return {
      isLoading: false,
      isEditing: false,
      formContainer: {},
      forms: [
        {
          name: '订单信息',
          wrapAttrs: {
            gutter: 10
          },
          attrs: {
            labelWidth: '100px',
            labelPosition: 'right',
          },
          formInfo: [
            {
              name: '订单编号',
              component: 'el-input',
              key: 'order_no',
              span: 8,
              attrs: {
                disabled: true
              }
            },
            {
              name: '域名',
              component: 'el-input',
              key: 'domain_name',
              span: 8,
              attrs: {
                disabled: true
              }
            },
            {
              name: '下单时间',
              component: 'el-input',
              key: 'created_at',
              span: 8,
              attrs: {
                disabled: true
              }
            },
            {
              name: '支付方式',
              component: 'el-input',
              key: 'payment',
              span: 8,
              attrs: {
                disabled: true
              }
            },
            {
              name: '地区',
              component: 'el-input',
              key: 'areaName',
              span: 8,
              attrs: {
                disabled: true
              }
            },
            {
              name: '订单状态',
              component: 'MultiSelect',
              key: 'state',
              span: 8,
              attrs: {
                options: [
                  {
                    name: '货到付款',
                    value: 1
                  },
                  {
                    name: '711',
                    value: 2
                  },
                  {
                    name: '全家',
                    value: 3
                  }
                ],
                disabled: true
              }
            }
          ]
        },
        {
          name: '客户信息',
          wrapAttrs: {
            gutter: 10
          },
          attrs: {
            labelWidth: '100px',
            labelPosition: 'right',
          },
          formInfo: [
            {
              name: '姓名',
              component: 'el-input',
              key: 'name',
              span: 12,
              attrs: {
                disabled: true
              }
            },
            {
              name: '手机',
              component: 'el-input',
              key: 'mobile',
              span: 12,
              attrs: {
                disabled: true
              }
            },
            {
              name: '邮箱',
              component: 'el-input',
              key: 'email',
              span: 12,
              attrs: {
                disabled: true
              }
            },
            {
              name: '邮编',
              component: 'el-input',
              key: 'postal',
              span: 12,
              attrs: {
                disabled: true
              }
            },
            {
              name: '地址',
              component: 'el-input',
              key: 'address',
              span: 12,
              attrs: {
                disabled: true
              }
            },
            {
              name: '省市区',
              component: 'AddrAreaInput',
              key: 'addrs',
              span: 12,
              attrs: {
                disabled: true
              }
            },
            {
              name: '备注',
              component: 'el-input',
              key: 'message',
              span: 24,
              attrs: {
                type: 'textarea',
                rows: 4,
                disabled: true
              }
            }
          ]
        },
        {
          name: '产品信息',
          formInfo: [
            {
              component: 'OrderProductsTable',
              key: 'sg_order_items',
              span: 24,
              attrs: {
                disabled: true
              }
            }
          ]
        },
        {
          name: '系统信息',
          wrapAttrs: {
            gutter: 10
          },
          attrs: {
            labelWidth: '100px',
            labelPosition: 'right',
          },
          formInfo: [
            {
              name: 'IP地址',
              component: 'el-input',
              key: 'ip',
              span: 24,
              attrs: {
                disabled: true
              }
            }
          ]
        }
      ],
      data: {}
    }
  },
  computed: {
    value() {
      return this.$store.state.pageValue
    },
    viewType() {
      return this.$store.state.viewType
    },
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  watch: {
    $route() {
      this.init()
    },
    isEditing(newState) {
      this.updateForm(newState)
    }
  },
  methods: {
    updateForm(isEditing) {
      if (isEditing) {
        [
          [],
          ['name', 'mobile', 'email', 'postal', 'address'],
          ['sg_order_items']
        ].map((formKeys, formIndex) =>{
          formKeys.map((key) => {
            this.setFormAttr(formIndex, key, {
              disabled: false
            })
          })
        })

        this.setFormAttr(0, 'state', {
          options: [
            {
              name: '待审核',
              value: 1
            },
            {
              name: '已通过',
              value: 2
            },
            {
              name: '作废',
              value: 3
            }
          ],
          disabled: false
        })

        this.setFormAttr(1, 'message', {
          type: 'textarea',
          rows: 4,
          disabled: false
        })
      } else {
        [
          [],
          ['name', 'mobile', 'email', 'postal', 'address'],
          ['sg_order_items']
        ].map((formKeys, formIndex) =>{
          formKeys.map((key) => {
            this.setFormAttr(formIndex, key, {
              disabled: true
            })
          })
        })

        this.setFormAttr(0, 'state', {
          options: [
            {
              name: '待审核',
              value: 1
            },
            {
              name: '已通过',
              value: 2
            },
            {
              name: '作废',
              value: 3
            }
          ],
          disabled: true
        })


        this.setFormAttr(1, 'message', {
          type: 'textarea',
          rows: 4,
          disabled: true
        })
      }
    },


    // 更新表单的attrs属性
    setFormAttr(index, key, attr) {
      let form = this.forms[index].formInfo
      let res = form.find((item) => {
        return item.key === key
      })
      if (res) {
        this.$set(res, 'attrs', attr)
      } else {
        console.log('没找到')
      }

    },

    async Submit() {
      let formHasError = false
      let result = {}
      if (Array.isArray(this.$refs.form)) {
        result = this.$refs.form.reduce((finalForm, formData) => {
          let {hasError, form} = formData.getFormData()
          if (hasError) formHasError = hasError
          finalForm = Object.assign(finalForm, form)
          return finalForm
        }, {})
      } else {
        let {hasError, form} = this.$refs.form.getFormData()
        formHasError = hasError
        result = form
      }

      // 最终处理数据
      if (formHasError) return
      let {addrs, areaName, payment, state, sg_order_items,...finalResult} = result
      finalResult.status = state
      finalResult.order_item = sg_order_items
      let res = await this.$api.UpdateOrder(finalResult)
      this.$router.go(-1)
    },
    async GetData() {
      this.isLoading = true
      let {id} = this.$route.query
      let res = {
        data: {}
      }

      if (id) {
        res = await this.$api.GetOrder(id)
        console.log()
        let language = getLanguage(res.id_poi_area)

        res.payment = paymentType[language][res.payment]
        res.state = stateMap[res.status]
        res.areaName = res.sg_area.name
        res.addrs = [res.province, res.city, res.district]
        this.isLoading = false
      } 
      this.$store.commit('setDialogValue', res)
      this.isLoading = false
    },
    init() {
      this.$store.commit('setViewType', this.$route.meta.viewType)
      this.GetData()
    }
  },
  mounted  () {
    this.init()
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/style/index.less';
.form {
  margin-bottom: 10px;
}

</style>